import { jsx as _jsx } from "react/jsx-runtime";
import { Section } from "@/components/UI";
import { ContactCardMobile } from "@/components/contacting";
export const ContactCard = () => {
    return (_jsx(Section, { unsafeClassname: "HideOnPrint", BoxProps: {
            display: {
                "breakpoint.base": "block",
                "breakpoint.lg": "none",
            },
            paddingTop: "spacing.16",
        }, DividerBoxProps: {
            display: {
                "breakpoint.base": "block",
                "breakpoint.lg": "none",
            },
        }, children: _jsx(ContactCardMobile, {}) }));
};
